import React from 'react';

function HireSection({ hireRef }) {
  return (
    <section ref={hireRef} style={s.hireSection}>
      <div style={s.hireSectionInner}>
        <h2 style={s.hireHeadline}>Got an app idea?</h2>
        <p style={s.hireSub}>
          We take on select client projects. If you have an idea you'd like
          brought to life, we'd love to hear about it.
        </p>
        <a href="/contact" style={s.hireBtn}>
          Let's talk
        </a>
        <p style={s.freeNote}>No charge to get a quote. We don't charge for conversations or estimates.</p>
      </div>
    </section>
  );
}

const s = {
  hireSection: {
    padding: '80px 24px',
    background: '#1c1c1e',
    textAlign: 'center',
  },
  hireSectionInner: { maxWidth: 560, margin: '0 auto' },
  hireHeadline: {
    fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    color: '#f9f9f7',
    margin: '0 0 16px',
  },
  hireSub: {
    fontSize: '1rem',
    color: '#9ca3af',
    lineHeight: 1.7,
    margin: '0 0 36px',
  },
  freeNote: {
    marginTop: 20,
    fontSize: '0.8rem',
    color: '#4a4f66',
    lineHeight: 1.6,
  },
  hireBtn: {
    display: 'inline-block',
    background: '#f9f9f7',
    color: '#1c1c1e',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 700,
    padding: '13px 28px',
    borderRadius: 10,
    letterSpacing: '0.01em',
  },
};

export default HireSection;
